import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Button from '@ecp/common/src/components/button/bo/Button';

import { ContentTitle } from '@bo-components/common/styled';
import Form from '@bo-components/common/form/Form';
import FormField from '@bo-components/common/form/FormField';

const MemberInfo = ({ siteBasicInfo }) => {
  const siteStd = useMemo(
    () =>
      `${
        siteBasicInfo.siteStandardSettleYn === 'Y'
          ? `사이트 기준(${siteBasicInfo.settleStandardCodeName})`
          : '공급업체 기준'
      }`,
    [siteBasicInfo]
  );

  const handleMoveTo = () => {
    window.open('/settlement/good-settlement');
  };

  return (
    <FlexBoxColumn width={'100%'} align-items={'flex-start'}>
      <FlexBox justify-content={'space-between'} width={'100%'}>
        <ContentTitle type={'secondary'} width={'100%'}>
          정산환경
        </ContentTitle>
        <Button type={'Third'} move onClick={handleMoveTo}>
          정산관리
        </Button>
      </FlexBox>
      <Spacing bottom={'8px'} />
      <Form>
        <FormField label={'정산구분'}>
          <TextBox>{siteBasicInfo.siteSettleDivisionCodeName}</TextBox>
        </FormField>
        <FormField label={'포함여부'}>
          <TextBox>{siteBasicInfo.siteAutoSettleYn === 'Y' ? '포함(자동정산)' : '예외(수동정산)'}</TextBox>
        </FormField>
        <FormField label={'정산기준'} full>
          <TextBox>{siteStd}</TextBox>
        </FormField>
      </Form>
    </FlexBoxColumn>
  );
};

export default MemberInfo;

MemberInfo.propTypes = {
  siteBasicInfo: PropTypes.object,
};
